document.addEventListener("DOMContentLoaded", () => {
  const accordions = document?.querySelectorAll("[data-gaccordion]");
  accordions?.forEach((accordion) => {
    const title = accordion.querySelector("[data-gaccordion-title]");
    const content = accordion.querySelector("[data-gaccordion-content]");

    if (!title) {
      console.error(
        "Укажите заголовок аккордеона аттрибутом «data-gaccordion-title»"
      );
    }

    if (!content) {
      console.error(
        "Укажите контент аккордеона аттрибутом «data-gaccordion-content"
      );
    }

    if (!accordion.querySelector(".gaccordion-button")) {
      // Добавляю иконку
      const button = `<button class="gaccordion-button button-reset"></button>`;
      title.insertAdjacentHTML("beforeend", button);
    }

    // Получаю высоту контента
    const contentHeight = parseInt(content.scrollHeight) + 30;
    accordion.style.setProperty("--content-height", `${contentHeight}px`);

    // Доабвляю логику открывания
    title.addEventListener("click", (e) => {
      accordion.classList.toggle("gaccordion-open");
    });
  });
});
